import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useInvoicesTickets from '../useInvoicesTickets';
import { Chart } from 'react-google-charts';
import LineChart from '../../../charts/lineChart';
import BarChangeChart from '../../../charts/barChange';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    title,
    data,
    columns,
    filters,
    format,
    loading,
    handleDownloadExcel,
    summary,
    searchParams,
    loadingPdf,
    handleDownloadPdf,
    errors,
  } = useInvoicesTickets();
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Tickets').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              loading={loadingPdf}
              onClick={() => handleDownloadPdf(title)}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        <AlertMessage errors={errors} searchParams={searchParams} />
        <Spin spinning={loading}>
          <Row className={styles.titleSection} justify={'center'}>
            <Col>
              <Typography.Title level={3}>{title}</Typography.Title>
            </Col>
          </Row>
          <Row>
            <Col xs={24} xxl={12}>
              <Table
                loading={loading}
                columns={UIHelper.assignTire(columns)}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                summary={summary}
              />
            </Col>
            <Col xs={24} xxl={12}>
              <LineChart
                data={data.lineChartData}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                formatTooltip={(v) => Helpers.numberWithCommas(v)}
              />
              <br />
              <BarChangeChart
                keys={['Tickets LY', 'Tickets YTD']}
                data={data}
                format={format}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
